import { useParams } from "react-router-dom";

import { useQuoteRequestLine } from "#modules/quoteRequestLines/view/useQuoteRequestLine";
import { useUpdateCluster } from "#modules/similarPart/infra/clustering/useUpdateCluster";
import { BackToClusterButton } from "#modules/similarPart/view/clustering/BackToClusterButton";
import { CompareCard } from "#modules/similarPart/view/clustering/CompareCard";
import { EstimateButton } from "#modules/similarPart/view/clustering/EstimateButton";
import { SidePartCard } from "#modules/similarPart/view/clustering/SidePartCard";
import { Alert } from "#shared/view/components/Alert";
import { Flex } from "#shared/view/components/Flex";
import { Grid } from "#shared/view/components/Grid";
import { Loader } from "#shared/view/components/Loader";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

const PAGE_PADDING = "xs";

export const CompareClusterPage = () => {
  const { quoteRequestLineId } = useParams();
  const { quoteRequestLine: sourceQuoteRequestLine, isLoading } = useQuoteRequestLine({
    id: quoteRequestLineId ?? "",
  });

  const { updateCluster } = useUpdateCluster();

  const cluster = sourceQuoteRequestLine?.cluster?.targetQuoteRequestLines ?? [];

  const removeFromCluster = (id: string | undefined) => {
    if (!id) {
      return;
    }

    const newCluster = cluster.filter((qrl) => qrl.id !== id).map((qrl) => qrl.id);

    updateCluster({
      sourceId: sourceQuoteRequestLine?.id ?? "",
      cluster: newCluster,
    });
  };

  if (isLoading) {
    return <Loader />;
  }

  if (!sourceQuoteRequestLine) {
    return <Alert title="La demande de devis n'existe pas" variant="error" />;
  }

  return (
    <Flex gap={"md"} p={PAGE_PADDING}>
      <SidePartCard sourceQuoteRequestLine={sourceQuoteRequestLine} />

      <Stack
        w={"100%"}
        h="calc(100% - var(--header-height))"
        mih={`calc(100vh - var(--header-height) - (2*var(--mantine-spacing-${PAGE_PADDING})))`}
        justify="space-between"
      >
        <Stack gap={"lg"}>
          <Stack gap={0}>
            <Text fz="h1" fw={600}>
              Comparer les pièces sélectionnées
            </Text>
            <Text>Affinez votre cluster et passez à l'estimation</Text>
          </Stack>

          <Grid columns={12} gap="xs" justify="flex-start">
            {cluster.map((qrl) => {
              return (
                <Grid.Col key={qrl.id} span={3}>
                  <CompareCard
                    targetPart={qrl}
                    sourceQuoteRequestLine={sourceQuoteRequestLine}
                    removeFromCluster={removeFromCluster}
                  />
                </Grid.Col>
              );
            })}
          </Grid>
        </Stack>

        <Flex gap="xs" justify="space-between">
          <BackToClusterButton quoteRequestLine={sourceQuoteRequestLine} variant="outline" />

          <EstimateButton quoteRequestLine={sourceQuoteRequestLine} />
        </Flex>
      </Stack>
    </Flex>
  );
};
